module.exports = __webpack_public_path__ + "img/background-1.420acf6d.png";